import { formatValueDate } from "@/components/widgets/helpers/FormattingHelpers";

export const getDateFieldForEarningsCalendar = (date: Date): string => {
	if (Number.isNaN(date.getTime())) return "act_rpt_date";

	const inputDate = new Date(formatValueDate(date));
	const today = new Date(formatValueDate(new Date()));

	return inputDate < today ? "act_rpt_date" : "next_rpt_date";
};
